import React, { useEffect } from 'react';
import { Switch, Route, withRouter } from 'react-router';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import queryString from 'query-string';

import routes from '../../routes';
import Nav from '../../components/Nav';
import theme from '../../theme';

import Footer from '../../components/Footer';

import { AppContainer, Content } from './App.styles';

import { setInitialPageview } from '../../store/session/actions';

import { GlobalStyle } from '../../index.styles';
import { savePiwikParams, method as piwikMethod } from '../../utils';


export const EventRoute = (props) => {
  // For the gtag implementation, we want it to fire one time in the head and then skip the inital
  // pageview being fired here.
  const initialPageviewHappened = useSelector(state => state.session.initialPageview);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!initialPageviewHappened) {
      dispatch(setInitialPageview());
    }
    piwikMethod(`setDocumentTitle`, [document.title]);
    piwikMethod(`setCustomUrl`, [props.location.pathname + props.location.search]);
    piwikMethod(`trackPageView`, []);

    if (initialPageviewHappened && window.gtag) {
      window.gtag(`config`, `UA-154790024-1`, {
        page_title: document.title,
        page_path: props.location.pathname + props.location.search
      });
    }
  }, [props.location]);

  return <Route { ...props } />;
}

const App = (routing) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const parsed = queryString.parse(routing.location.search);

    savePiwikParams(parsed);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <AppContainer>
        <Helmet>
          <html lang="en" />
          <link
            rel="shortcut icon"
            type="image/png"
            href="https://storage.googleapis.com/lucina-assets/QS_Favicon.png"
          />
          <link rel="dns-prefetch" href="https://quickscope.minervaarticles.com/" />
          <link rel="preconnect" href="https://connect.facebook.net/" />
          <link rel="preconnect" href="https://facebook.com" />
          <link rel="preconnect" href="https://cdn.aimtell.com/" />
          <link rel="preconnect" href="https://d21xyhlfezdkqu.cloudfront.net" />
          <link rel="canonical" href={`https://www.thequickscope.com${pathname}`} />
          <title>{`Gaming News | Daily Video Game & PC Gaming News at Quickscope`}</title>
          <meta name="og:title" property="og:title" content="Gaming News | Daily Video Game & PC Gaming News at Quickscope" />
          <meta
            name="og:description"
            property="og:description"
            content="Get all the latest gaming news delivered straight to your inbox daily. Sign up for Quickscope and stay in the know about all the latest games for free!"
          />
          <meta
            name="description"
            property="description"
            content="Get all the latest gaming news delivered straight to your inbox daily. Sign up for Quickscope and stay in the know about all the latest games for free!"
          />
          <meta name="keywords" property="keywords" content="video game newsletter, gaming newsletter, video game email, how to stay up to date with video games, video game news, new games, game websites" />
          <meta name="og:type" property="og:type" content="website" />
          <meta name="og:url" property="og:url" content="https://www.thequickscope.com" />
          <meta name="og:site_name" property="og:site_name" content="Quickscope" />
          <meta
            name="og:image"
            property="og:image"
            content="https://storage.googleapis.com/lucina-assets/quickscope_og.png"
          />
          <meta name="twitter:site" property="twitter:site" content="@TheQSNews" />
          <meta name="twitter:title" property="twitter:title" content="Video Gaming News - Daily Email Newsletter | Quickscope" />
          <meta name="twitter:description" property="twitter:description" content="Curated and analyzed news from likable & trusted sources in the video game industry and delivered right to your inbox. A daily email newsletter for gamers by gamers." />
          <meta name="twitter:image" property="twitter:image" content="https://storage.googleapis.com/lucina-assets/quickscope_og.png" />
          <meta name="twitter:card" property="twitter:card" content="summary_large_image" />
        </Helmet>
        <GlobalStyle />
        <Nav />
        <Content>
          <Switch>
            {routes.map((r) => (
              <EventRoute {...r} />
            ))}
          </Switch>
        </Content>
        <Footer />
      </AppContainer>
    </ThemeProvider>
  );
}

export default withRouter(App);